<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">{{headName}}</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addressAEForm" :rules="rules" ref="addressAEForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="收货人" required prop="receiveName">
                                    <el-input v-model="addressAEForm.receiveName" placeholder="请填写收货人名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="手机号" required prop="receivePhone">
                                    <el-input v-model="addressAEForm.receivePhone" maxlength="11" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="地区" required prop="areaCode">
                                    <el-cascader
                                        placeholder="请选择所属地区"
                                        v-model="addressAEForm.areaCode"
                                        :options="areaValue"
                                        :props="props"
                                         style="width:100%">
                                    </el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="详细地址" required prop="receiveAddress">
                                    <el-input v-model="addressAEForm.receiveAddress" placeholder="请输入详细地址"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addressAEForm')">提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'AddressAE',
        props: ["areaValue"],
        data() {
            return {
                loading: false,
                goodsType: '',
                headName: '地址新增',
                url: '',
                props: {
                    emitPath:false,
                    value: 'areaCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listAreaDTO'
                },
                elderly:'',
                addressAEForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    areaCode:'',
                    receiveAddress:'',
                    receiveName:'',
                    receivePhone:'',
                    userAddressCode:''
                },
                rules:{
                    receiveName:[
                        { required: true, message: '请填写收货人名称', trigger: 'blur' },
                    ],
                    receiveAddress:[
                        { required: true, message: '请输入详细地址', trigger: 'blur' },
                    ],
                    receivePhone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        }
                    ],
                    areaCode:[
                        { required: true, message: '请选择所属地区', trigger: 'blur' },
                    ],
                },
            }
        },

        methods: {
            init(row,elderlyCode){
                console.log(elderlyCode)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/GetByElderlyCode",
                    data:{
                        elderlyCode:elderlyCode
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.elderly=response.data.data;
                            console.log(this.elderly)
                            this.addressAEForm.receiveName=this.elderly.name;
                            this.addressAEForm.receivePhone=this.elderly.userPhone;
                            this.addressAEForm.areaCode=this.elderly.areaCode;
                            this.addressAEForm.receiveAddress=this.elderly.homeAddress
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
                this.addressAEForm.elderlyCode=elderlyCode
                this.addressAEForm.userAddressCode=row.userAddressCode
                if(row){
                    this.url=this.$shopUrl+"UserAddress/EditForStaff"
                    this.headName="地址编辑"
                    this.addressAEForm.areaCode=row.areaCode
                    this.addressAEForm.receiveAddress=row.receiveAddress
                    this.addressAEForm.receiveName=row.receiveName
                    this.addressAEForm.receivePhone=row.receivePhone
                }else{
                    this.url=this.$shopUrl+"UserAddress/AddForStaff"
                    this.$refs.addressAEForm.resetFields();
                }
                
            },
            closeSelf() {
                this.$emit("closeAddressAE");
            },
            confirm(addressAEForm){
                this.$refs[addressAEForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();

                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addressAEForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.url,
                    data: this.addressAEForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error === 0) {
                          this.$emit("getAddress");
                          this.$emit("closeAddressAE");
                        }else if(response.data.error === 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>

f